module.exports = __webpack_public_path__ + "static/media/menu1_cont_03.842f0bf9.png";